import { render, staticRenderFns } from "./ImageExtended.vue?vue&type=template&id=2b35ffd8&scoped=true"
import script from "./ImageExtended.vue?vue&type=script&lang=js"
export * from "./ImageExtended.vue?vue&type=script&lang=js"
import style0 from "./ImageExtended.vue?vue&type=style&index=0&id=2b35ffd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35ffd8",
  null
  
)

export default component.exports